import { render, staticRenderFns } from "./ListModal.vue?vue&type=template&id=54f37b3e&"
import script from "./ListModal.vue?vue&type=script&lang=js&"
export * from "./ListModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports